OT.createNS('OT.Redesign.Views.Results.ShortlistButton');

OT.Redesign.Views.Results.ShortlistButton = Backbone.ViewManager.BaseView.extend({
    template: "Redesign/Results/_ShortlistButton",

    events: {
        'click button': 'toggle',
    },

    initialize: function () {
        this.restaurantId = $(this.el).find(".shortlist-button").data('restaurant-id');
        this.restaurantTitle = $(this.el).find(".shortlist-button").data('restaurant-title');
        this.restaurantUri = $(this.el).find(".shortlist-button").data('restaurant-uri');
        this.profileUri = $(this.el).find(".shortlist-button").data('profile-uri');
        this.reviews = $(this.el).find(".shortlist-button").data('reviews');
        this.toggle = this.toggle.bind(this);
        this.onUpdatedEvent = this.onUpdatedEvent.bind(this);
        this.isInShortlist = false;
        this.isDisabled = false;

        OT.Events.on("shortlist:updated", this.onUpdatedEvent);
    },

    onUpdatedEvent: function (e, restaurantIds) {
        var self = this;
        var restaurantInShortlist = restaurantIds.indexOf(self.restaurantId) !== -1;
        if(restaurantInShortlist && !self.isInShortlist) {
            self.isInShortlist = true;
        } else if (!restaurantInShortlist && self.isInShortlist) {
            self.isInShortlist = false;
        }
        if(restaurantIds.length >= 4 && !self.isInShortlist) {
            self.isDisabled = true;
        } else {
            self.isDisabled = false;
        }
        this.renderButton();
    },

    toggle: function () {
        var restaurant = {
            restaurantId: this.restaurantId,
            restaurantTitle: this.restaurantTitle,
            restaurantUri: this.restaurantUri,
            reviews:this.reviews,
            profileUri:this.profileUri
        };
        this.isInShortlist = !this.isInShortlist;
        if(this.isInShortlist) {
            OT.Events.fire("shortlist:add", [restaurant]);
        }
        else if(!this.isInShortlist) {
            OT.Events.fire("shortlist:delete", [{restaurantId: this.restaurantId}]);
        }
    },

    beforeRender: function () {
        this.additionalData = {
            isInShortlist: this.isInShortlist,
            isDisabled: this.isDisabled,
        };
        return this;
    },

    renderButton: function (){
        if (this.isInShortlist) {
            $(this.el).find(".shortlist-button").addClass("shortlist-button-isInShortlist");
        } else {
            $(this.el).find(".shortlist-button").removeClass("shortlist-button-isInShortlist");
        }

        if (this.isDisabled) {
            $(this.el).find(".shortlist-button").addClass("shortlist-button-isDisabled");
        } else {
            $(this.el).find(".shortlist-button").removeClass("shortlist-button-isDisabled");
        }

        $(this.el).find("button").attr("aria-disabled",this.isDisabled);
        $(this.el).find("button").attr("aria-pressed",this.isInShortlist);
    },

    dispose: function() {
        OT.Events.remove("shortlist:updated", this.onUpdatedEvent);
    }
})